<script>
	let {
		title = null,
		backgroundColor = null,
		class: className = '',
		titleSlot = null,
		inner = null,
		children = null,
	} = $props();
</script>

<div
	class={[
		`
    mx-auto mb-8 grid w-full max-w-xl items-center justify-items-center
    justify-self-center rounded-lg px-8 py-7
  `,
		{ 'bg-indow-white': backgroundColor == 'white' },
		{ 'bg-indow-blue': backgroundColor == 'blue' },
		{ 'bg-indow-grey-light': backgroundColor == 'grey-light' },
		{ 'bg-indow-grey': backgroundColor == 'grey' },
		{ 'bg-indow-grey-dark': backgroundColor == 'grey-dark' },
		{ 'bg-transparent': backgroundColor == 'transparent' },
		{ 'shadow-md': backgroundColor != 'transparent' },
		className,
	]}
>
	{#if title || titleSlot}
		{#if titleSlot}{@render titleSlot()}{:else}
			<h3 class="text-left">
				{title}
			</h3>
		{/if}
	{/if}

	{#if inner}{@render inner()}{:else}
		{@render children?.()}
	{/if}
</div>
